const defaultquerySerializer = obj => {
  if (typeof obj !== 'object') {
    return '';
  }

  return Object.keys(obj)
    .filter(key => obj[key] !== undefined)
    .map(key => `${key}=${encodeURIComponent(obj[key])}`)
    .join('&');
};

export function makeUrl(url, query, querySerializer = defaultquerySerializer) {
  if (!query) {
    return url;
  }

  const queryString = querySerializer(query);

  const urlWithQuery = /\?/.test(url) ? `${url}&${queryString}` : `${url}?${queryString}`;
  return urlWithQuery.replace('?&', '?');
}

export function parseQueryString(str) {
  let queryString = str;
  if (queryString.indexOf('?') === 0) {
    queryString = queryString.slice(1);
  }

  const vars = queryString.split('&');
  const query = {};
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    const value = pair[1] === undefined ? '' : decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query[pair[0]] === 'undefined') {
      query[pair[0]] = value;
      // If second entry with this name
    } else if (typeof query[pair[0]] === 'string') {
      const arr = [query[pair[0]], value];
      query[pair[0]] = arr;
      // If third or later entry with this name
    } else {
      query[pair[0]].push(value);
    }
  }
  return query;
}

export const urlQuery = parseQueryString(window.location.search);
